module.exports = __webpack_public_path__ + "assets/img/events-point-08.900ca7a4.png";